import { Controller } from '@hotwired/stimulus'
import { firePlausibleGoal } from '@/libraries/plausible'

export default class extends Controller {
  static values = { eventLabel: String }

  declare eventLabelValue: string

  createCompany() {
    firePlausibleGoal('company#create')
  }

  createUser() {
    firePlausibleGoal('user#create')
  }

  extendTrial() {
    firePlausibleGoal('trial_period#extend')
  }

  activateSubscription() {
    firePlausibleGoal(`subscription#activate`, { subscription: this.eventLabelValue })
  }

  foundCompanyStepReached() {
    const availableLabels = ['user_created', 'found_document_signed', 'sent_to_altinn']
    if (availableLabels.includes(this.eventLabelValue)) {
      firePlausibleGoal(`found_company#step_reached#${this.eventLabelValue}`)
    } else {
      console.error(`We don't support ${this.eventLabelValue} label`)
    }
  }
}
